export default __webpack_public_path__ + "static/media/delete.0148cf37.svg";